import React, { useState } from 'react'
import { fetchArtistContentBlocks } from 'shared/api'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { giphyAqua } from '@giphy/js-brand'
import { IContentBlock } from './types'
import Blocks from './components/blocks'
import { ContentBlockContext } from './context'

type Props = {
    className?: string
    width?: number
}

const ArtistContentBlocks = ({ className, width }: Props) => {
    const [blocks, setBlocks] = useState<IContentBlock[]>([])

    useAsyncEffect(async () => {
        const { results } = await fetchArtistContentBlocks()
        setBlocks(
            results
                .filter(({ is_private, featured_gif }) => !is_private && !!featured_gif)
                .map(({ id, user, featured_gif, url, display_name }) => ({
                    id,
                    url,
                    user,
                    label: display_name || user.display_name || user.username,
                    gif: featured_gif,
                }))
        )
    }, [])

    return (
        <ContentBlockContext.Provider
            value={{
                title: 'GIPHY Artists',
                labelColor: giphyAqua,
                seeAllUrl: '/artists',
                width,
            }}
        >
            <Blocks blocks={blocks} className={className} />
        </ContentBlockContext.Provider>
    )
}

export default ArtistContentBlocks
